import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';

const featureRootSelector = createFeatureSelector('pdpNavigation');

export const getSectionsMetaCollection = createSelector(featureRootSelector, (f) => f.sectionMetas);
export const getPageNavContext = createSelector(featureRootSelector, (f) => f.context);

export const getSectionMeta = (sectionId: string) =>
  createSelector(featureRootSelector, (f) => f.sectionMetas.find((s) => s.sectionId === sectionId));
